/**
 * Single pricing tier card. `features` is [{ label, included: bool }].
 * `cta` is either { to: "/path" } (internal), { href: "#anchor" } (external/anchor),
 * or just the label + variant. `featured` adds the orange border + badge.
 */
function PricingCard({
  plan,
  forWhom,
  price,        // number/string e.g. "0", "1,000", or "Custom"
  rupee = true, // show ₹ prefix
  suffix,       // "/mo", "/student/mo", etc.
  customPrice = false, // true for Enterprise "Custom" styling
  period,
  features,
  cta,
  featured = false,
  badge,
}) {
  return (
    <div className={`ul-pricing-card${featured ? " featured" : ""}`}>
      {badge ? <div className="ul-pricing-badge">{badge}</div> : null}
      <div className="ul-pricing-plan">{plan}</div>
      <div className="ul-pricing-for">{forWhom}</div>
      <div className={`ul-pricing-price${customPrice ? " custom" : ""}`}>
        {rupee && !customPrice ? <span className="rupee">₹</span> : null}
        {price}
        {suffix ? <span className="sfx">{suffix}</span> : null}
      </div>
      <div className="ul-pricing-period">{period}</div>
      <hr className="ul-pricing-divider" />
      <ul className="ul-pricing-features">
        {features.map((f, i) => (
          <li key={i}>
            <span className={f.included ? "ul-pf-check" : "ul-pf-cross"} aria-hidden="true">
              {f.included ? "✓" : "✗"}
            </span>
            <span className="ul-pf-label">{f.label}</span>
            {f.note ? <span className="ul-pf-note" aria-hidden="true">{f.note}</span> : null}
          </li>
        ))}
      </ul>
      {cta}
    </div>
  );
}

export default PricingCard;
